import { render, staticRenderFns } from "./Appointmentallocation.vue?vue&type=template&id=3a2dd606"
import script from "./Appointmentallocation.vue?vue&type=script&lang=js"
export * from "./Appointmentallocation.vue?vue&type=script&lang=js"
import style0 from "./Appointmentallocation.vue?vue&type=style&index=0&id=3a2dd606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports